import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UserQrGeneratorModelComponent } from '../user-qr-generator-model/user-qr-generator-model.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../core/api.service';
import { UtilityService } from '../../../core/global/utility.service';
import { FunctionsService } from '../../../core/global/functions.service';
import { Location } from '@angular/common'
import * as moment from 'moment';
@Component({
  selector: 'app-users-details',
  templateUrl: './users-details.component.html',
  styleUrls: ['./users-details.component.sass']
})
export class UsersDetailsComponent implements OnInit {
  userList = [];
  deleteID = '';
  modalConfirmation;
  searchInput: any = '';
  sortedtby: any = 'id';
  sorttype: any = 'asc'
  page: number = 1; // Enter 1 if you want to use the server side pagination 
  p;
  limit = 10
  count
  last
  salt = 'Momentum2021'
  userType: string;
  id = '';
  name = '';
  day = '';
  dining = '';
  totalPages = [];
  start_date
  constructor(private location: Location, private modalService: NgbModal, private route: ActivatedRoute, private router: Router, private _adminService: ApiService, private _utility: UtilityService, private _function: FunctionsService) { }
  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      // Get the date parameter
      this.start_date=params['event_start']

    });
    this.id = this.route.snapshot.paramMap.get('id');
    let name = this.route.snapshot.paramMap.get('name');
    let arr = name.split('-');
    this.name = arr[0];
    this.day = arr[1]
    this.dining = arr[2];
    this.userType = localStorage.getItem('m_ind_type');
    this.getUserLog();
  }
  date(date) {
    const startDateMoment = moment(this.start_date, "YYYY-MM-DD");
    if (date === '1') {
      return startDateMoment.format("YYYY-MM-DD");
    }
    if (date === '2') {
      return startDateMoment.add(1, 'days').format("YYYY-MM-DD");
    }
    if (date === '3') {
      return startDateMoment.add(2, 'days').format("YYYY-MM-DD");
    }
  }
  
  getUserLog() {
    if (!this.day) {
      let url = "qr/user_log_list";
      let wheredata = []
      if (this.name == 'org') {
        wheredata = [{ 'field': '`qr_user_log`.`org_ref_id`', 'value': this.id, 'type': 'WHERE', 'nested': '' },
        ]
      } if (this.name == 'gate') {
        wheredata = [{ 'field': '`qr_user_log`.`gate_no`', 'value': this.id, 'type': 'WHERE', 'nested': '' },
        ]
      }
      let data = { searchText: this.searchInput, sortby: this.sortedtby, sorttype: this.sorttype, page: this.page, whereData: wheredata };
      this._utility.showLoader();
      this._adminService.post(url, data).subscribe((response) => {
        this._utility.hideLoader();
        if (response.status == 200) {
          this.userList = response.data;
          this.count = response.total;
          this.limit = response.limit;
          for (var j = 0; j < response.pages; j++) {
            this.totalPages[j] = j + 1;
          }
          this.last = response.pages;
        } else {
          this._utility.toastError(response.message);
        }
      })
    } else {
      this.geLogByDay()
    }
  }

  geLogByDay() {
    let url = "qr/user_log_by_day";
    let wheredata = []
    if (this.name == 'org') {
      wheredata = [{ 'field': '`qr_user_log`.`org_ref_id`', 'value': this.id, 'type': 'WHERE', 'nested': '' },
      { 'field': "DATE_FORMAT(`qr_user_log`.`created_at`, '%Y-%m-%d')", 'value': this.date(this.day), 'type': 'AND', 'nested': '' }
      ]
    } if (this.name == 'gate') {
      wheredata = [{ 'field': '`qr_user_log`.`gate_no`', 'value': this.id, 'type': 'WHERE', 'nested': '' },
      { 'field': "DATE_FORMAT(`qr_user_log`.`created_at`, '%Y-%m-%d')", 'value': this.date(this.day), 'type': 'AND', 'nested': '' }
      ]
    }
    let data = { searchText: this.searchInput, sortby: this.sortedtby, sorttype: this.sorttype, page: this.page, whereData: wheredata, gate: this.id, day: this.day, dining: this.dining };
    this._utility.showLoader();
    this._adminService.post(url, data).subscribe((response) => {
      this._utility.hideLoader();
      if (response.status == 200) {
        this.userList = response.data;
        this.count = response.total;
        this.limit = response.limit;
        for (var j = 0; j < response.pages; j++) {
          this.totalPages[j] = j + 1;
        }
        this.last = response.pages;
      } else {
        this._utility.toastError(response.message);
      }
    })
  }
  paginate(page) {
    this.page = page;
    this.getUserLog();
  }
  back() {
    this.location.back();
  }
  openModal(Id) {
    window.localStorage.setItem('pushUserId', Id);
    const modalRef = this.modalService.open(UserQrGeneratorModelComponent, { centered: true, backdrop: "static", size: 'xl' }); // xl, lg , sm
    modalRef.result.then(async (result) => {
    }, (reason) => {
      //
    });
  }
}
